<template>
  <div
    id="app"
    :class="[
      $route.name ? 'page-' + $route.name : 'page-' + $route.slug,
      filterSidebarState ? 'explore-sidebar-open' : ''
      ]">
    <div>
      <Navbar v-if="authenticatedUser && passStatus === 'yes'" @toggleSidebar="toggleSidebar"></Navbar>
      <Statusbar></Statusbar>
      <!--<b-container
        fluid
        class="wrapper p-0"
        :class="{ 'admin-sidebar-open': showSidebar }"
        v-if="admin"
      >
        <Sidebar></Sidebar>
        <Spinner v-if="loading"></Spinner>
        <transition name="route" mode="out-in">
          <router-view :key="$route.fullPath"></router-view>
        </transition>

        <ExploreSidebar
          v-if="apiReady && $route.meta.explore"
        ></ExploreSidebar>
        <Statusbar></Statusbar>
        <idle-timer></idle-timer>
      </b-container>-->
      <b-container
        fluid
        class="wrapper p-0"
        :class="{ 'admin-sidebar-open': showSidebar }"
      >
        <Sidebar v-if="passStatus === 'yes'"></Sidebar>
        <Spinner v-if="loading"></Spinner>
        <transition name="route" mode="out-in">
          <router-view :key="$route.fullPath"></router-view>
        </transition>

        <ExploreSidebar
          v-if="apiReady && $route.meta.explore && isAuthenticatedUserHasAccess"
          key="filtersidebar"
        ></ExploreSidebar>
        <idle-timer></idle-timer>
      </b-container>
    </div>
  </div>
</template>

<script>
//import * as Sentry from "@sentry/vue";
import Vue from "vue";
import { mapActions, mapGetters, mapState } from "vuex";
import ExploreSidebar from "./components/Explore/ExploreSidebar/ExploreSidebar";
import Navbar from "./components/Layout/Navbar";
import Sidebar from "./components/Layout/Sidebar";
import Spinner from "./components/Layout/Spinner";
import Statusbar from "./components/Layout/Statusbar";
import IdleTimer from "./IdleTimer";

export default {
  name: "App",
  components: {
    ExploreSidebar,
    IdleTimer,
    Navbar,
    Sidebar,
    Statusbar,
    Spinner
  },
  data() {
    return {
      currentPage: "pools",
      showSidebar: false
    };
  },
  computed: {
    ...mapGetters(["authenticatedUser", "authenticatedUserFullName","isAuthenticated", "isAuthenticatedUserHasAccess"]),
    ...mapState({
      apiReady: state => state.api.apiReady,
      loading: state => state.api.loading,
      filterSidebarState: state => state.layout.filterSidebarState,
      passStatus: state => state.auth.passStatus
    })
  },
  watch: {
    $route(to) {
      this.showSidebar = to.meta.sidebar;
    },
    /*authenticatedUser(val) {
      if (val) {
        Sentry.setUser({
          auth: process.env.VUE_APP_AUTH_PROVIDER,
          name: this.authenticatedUserFullName
        });
      }
    }*/
  },
  mounted() {
    this.saveAuthenticatedUserInfo(Vue.prototype.$authService.mappedUserInfo());
    if (this.$router.currentRoute.meta.sidebar) {
      this.showSidebar = true;
    }
  },
  methods: {
    ...mapActions(["saveAuthenticatedUserInfo", "saveFilterSidebarState"]),
    toggleSidebar() {
      this.showSidebar = !this.showSidebar;
    },
    toggleExploreSidebar() {
      this.saveFilterSidebarState(!this.filterSidebarState);
    }
  }
};
</script>
<style lang="scss">
@import "styles/styles.scss";
@import "~@fortawesome/fontawesome-free/scss/fontawesome.scss";
@import "~@fortawesome/fontawesome-free/scss/regular.scss";
@import "~@fortawesome/fontawesome-free/scss/solid.scss";
@import "~bootstrap/scss/bootstrap.scss";
@import "~bootstrap-vue/src/index.scss";
@import "~vue-select/src/scss/vue-select.scss";
@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,300;0,400;0,500;0,600;0,700;1,400;1,500;1,800;1,900&display=swap');
.route-enter-from {
  opacity: 0;
}
.route-enter-active {
  transition: all 0.5s ease-out; 
}
.route-leave-to {
  opacity: 0;
}
.route-leave-active {
  transition: all 0.5s ease-in; 
}
</style>
